import { toPx } from '../../../utils/toPx';
import { setUiTransitionStyles } from '../../utils/styles/styles';
import { rgba } from '../../utils/color';
import { Theme } from 'foundations-theming';
import { SpaceStyleProps } from '../../../types';
import { css } from 'foundations-theming/utils';

const CHECKERBOARD_IMAGE = `<svg height="16" width="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path fill="%23F2F5F8" d="M0 0h16v16H0z"/>
      <g fill="%23CBD6E2">
        <path d="M8 8h8v8H8zM0 0h8v8H0z"/>
      </g>
    </g>
  </svg>`;

const getOpacityAffordance = ({ size }: { size: number }) => css`
  background-image: url('data:image/svg+xml;utf8,${CHECKERBOARD_IMAGE}');
  background-repeat: repeat;
  background-size: ${toPx(size / 2.5)};
`;

interface GetSquatchOuterStylesProps {
  hovered: boolean;
  selected: boolean;
  opacity: number;
  size: number;
  theme: Theme;
  $cssStyles: SpaceStyleProps;
}

export const getSquatchOuterStyles = (props: GetSquatchOuterStylesProps) => {
  const { hovered, selected, opacity, size, theme, $cssStyles } = props;

  const styles = css`
    opacity: ${opacity ? getOpacityAffordance({ size }) : 'initial'};
    border-radius: ${theme.borderRadius['100']};
    height: ${toPx(size)};
    width: ${toPx(size)};
    position: relative;
    ${setUiTransitionStyles('box-shadow')}
    ${selected &&
    css`
      box-shadow:
        0 0 0 1px ${rgba(theme.color['fill-surface-default'])},
        0 0 0 3px ${rgba(theme.color['border-accent-blue-default'])};
    `}
    ${hovered &&
    !selected &&
    css`
      box-shadow:
        0 0 0 2px ${rgba(theme.color['border-interactive-default'])},
        0 0 8px 0
          ${rgba(theme.color['temp-future-fill-secondary-default'], 0.3)};
    `}
    ${{ ...$cssStyles }}
  `;

  return styles;
};

interface GetAfterStylesProps {
  active: boolean;
  theme: Theme;
}

// TODO why are we changing the color via rgba() instead of using it as is given it already has opacity?
export const getAfterStyles = (props: GetAfterStylesProps) => css`
  background-color: ${rgba(props.theme.color['specialty-scrim'], 0.1)};
  border-radius: inherit;
  bottom: 0;
  content: '';
  display: ${props.active ? 'block' : 'none'};
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
